import { ColumnDef } from "@tanstack/react-table";
import { z, ZodObject, ZodRawShape } from "zod";
import LicensePlate from "license-plate";
import licencePlateSelectBg from "../../../general/fields/modules/commons/licencePlateSelectField/assets/licencePlateSelectBg.svg";
import { useTranslation } from "react-i18next";

export const CarTableColumns: ColumnDef<z.infer<ZodObject<ZodRawShape>>>[] = [
  {
    id: "licence",
    accessorKey: "licence",
    header: "licence",
    meta: {
      columnAction: "/car/:id/edit",
    },
    cell: ({ row }) => {
      const { t } = useTranslation("common");
      const plate = new LicensePlate(row.original?.licence ?? "");

      return (
        <div className={"d-flex align-items-center gap-2"}>
          {row.original?.licence && (
            <div
              className={"tireset-table-licence-plate"}
              style={{
                background: `url(${licencePlateSelectBg}) no-repeat center center / cover`,
              }}
            >
              <div>
                {plate.valid() ? plate.pretty() : row.original?.licence}
              </div>
            </div>
          )}
          <div>{row.original?.label}</div>

          {row.original?.freestock_tire && (
            <span className="badge text-bg-secondary">{t("Free stock")}</span>
          )}
        </div>
      );
    },
  },
  {
    id: "relation.name",
    accessorKey: "relation.name",
    header: "relation.name",
  },
  {
    id: "is_lease",
    accessorKey: "is_lease",
    header: "is_lease",
    cell: ({ row }) => {
      const { t } = useTranslation("common");
      return <div>{row?.original?.is_lease ? t("Yes") : t("No")}</div>;
    },
  },
];
